/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'icon-play': {
    width: 18,
    height: 18,
    viewBox: '0 0 18 18',
    data: '<path pid="0" d="M13.922 9.954l-8.71 5.054c-.74.428-1.688-.09-1.688-.954V3.945c0-.862.947-1.382 1.688-.952l8.71 5.054a1.097 1.097 0 010 1.907z" _fill="#fff"/>'
  }
})
